// extracted by mini-css-extract-plugin
module.exports = {"container":"a630f0e637--container--K68Zy","name":"a630f0e637--name--arvN5","address":"a630f0e637--address--UnMpm","phone":"a630f0e637--phone--GttUB"};